export default "__VITE_ASSET__DfTL4eHp__"